// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "css/chunks/" + {"33103":"DkPagination-vue","67002":"SearchBar-vue","78483":"DkButton-vue"}[chunkId] + ".4.17.3.css"; };